import paleta from './paleta';

class Palette {

    constructor() {
        this.colors = paleta.colors;
        this.colorList = paleta.colorList;
        this.chartColors = localStorage.paleta ? JSON.parse(localStorage.paleta) : paleta.chartColors;
        this.speedometerColors = this.getSpeedometerColor();
        this.barColors = localStorage.paleta ? JSON.parse(localStorage.paleta) : paleta.barColors;
        this.abcColors = this.getAbcColor();
    }

    getSpeedometerColor () {
        if (localStorage.paleta) {
            let colors = JSON.parse(localStorage.paleta);
            let sdc = this.getAbcColor().reverse();
            sdc.push(colors[colors.length-1])
            return sdc;
        }
        return paleta.speedometerColors;
    }

    getAbcColor () {
        if (localStorage.paleta) {
            const intensity = Number(localStorage.color_intensity);
            let abc = [];
            let colors = JSON.parse(localStorage.paleta);
            abc.push(colors[intensity > 0.8 ? 0 : 2]);
            abc.push(colors[intensity > 0.8 ? 2 : 0]);
            abc.push(colors[intensity > 0.8 ? 4 : 8]);
            return abc;
        }
        return paleta.abcColors;
    }

    getChartColors () {
        return localStorage.paleta ? JSON.parse(localStorage.paleta) : paleta.chartColors;
    }

    getBarColors () {
        return localStorage.paleta ? JSON.parse(localStorage.paleta) : paleta.barColors;
    }

}

export const palette = new Palette();